import {elementInScopeVertically, scrollToElementHorizontallyIfNeed} from "./common/ui";

(function () {
	const config = {
		selectorProhibitedGoodsBlock: '.sys__prohibited-goods-block',
		selectorFilterBlock: '.sys__filter-block',
		selectorFilterButton: '.sys__filter-button',
		prohibitedGoodsHiddenCssClass: 'prohibited-goods-block__hidden',
		filterBlockHiddenCssClass: 'prohibited-goods-block__sub-block--hidden',
		filterButtonCurrentCssClass: 'prohibited-goods-block__filter--current',
		stickyPanelHeight: 60,
	};

	function initUi() {
		const prohibitedGoodsBlocks = document.querySelectorAll(config.selectorProhibitedGoodsBlock)
		const countriesRadios = document.querySelectorAll('[name=countries__country]');
		const filterButtons = [...document.querySelectorAll(config.selectorFilterButton)];
		const filterBlocks = [...document.querySelectorAll(config.selectorFilterBlock)];
		const customsArticle = document.getElementById('soglasnotamozhennympravilamrfzapreshhenykperesylke')
		const customsNav = document.querySelector('[data-anchor-id="soglasnotamozhennympravilamrfzapreshhenykperesylke"]');

		function getCountry() {
			return [...countriesRadios]
				.filter(radioButton => radioButton.checked)
				.map(radioButton => radioButton.value)[0];
		}

		function scrollToFilterBlock(filterId) {
			const filterBlock = filterBlocks.find(el =>
				el.getAttribute('data-country-id') === getCountry() &&
				el.getAttribute('data-filter-id') === filterId
			);
			window.scrollTo({top: filterBlock.offsetTop - config.stickyPanelHeight, behavior: 'smooth'});
		}

		function toggleFilterButtonActiveState(targetFilterId) {
			filterButtons
				.filter(el => el.getAttribute('data-country-id') === getCountry())
				.forEach((filterButton) => {
					const filterId = filterButton.getAttribute('data-filter-id');
					if (targetFilterId === filterId) {
						scrollToElementHorizontallyIfNeed(filterButton.closest('li'), filterButton.closest('ul'));
					}
					filterButton.classList.toggle(config.filterButtonCurrentCssClass, targetFilterId === filterId);
				})
		}

		for (let countryRadio of countriesRadios) {
			countryRadio.addEventListener('change', function () {
				prohibitedGoodsBlocks.forEach(block => {
					const countryId = block.getAttribute('data-country-id');
					block.classList.toggle(config.prohibitedGoodsHiddenCssClass, countryRadio.value !== countryId);
					customsArticle.classList.toggle(config.prohibitedGoodsHiddenCssClass, countryRadio.value === 'AE')
					customsNav.classList.toggle(config.prohibitedGoodsHiddenCssClass, countryRadio.value === 'AE')
				});
			});
		}

		for (let filterButton of filterButtons) {
			filterButton.addEventListener('click', (event) => {
				event.preventDefault();
				scrollToFilterBlock(filterButton.getAttribute('data-filter-id'))
			})
		}

		document.addEventListener('scroll', function () {
			filterBlocks
				.filter(filterBlock => filterBlock.getAttribute('data-country-id') === getCountry())
				.every(filterBlock => {
					if (elementInScopeVertically(filterBlock, config.stickyPanelHeight)) {
						toggleFilterButtonActiveState(filterBlock.getAttribute('data-filter-id'));
						return false;
					}
					return true;
				})
		})
	}

	document.addEventListener('DOMContentLoaded', initUi);
})();